import { render } from "./UkraineResidencePopup.vue?vue&type=template&id=24c66827&scoped=true&ts=true"
import script from "./UkraineResidencePopup.vue?vue&type=script&lang=ts"
export * from "./UkraineResidencePopup.vue?vue&type=script&lang=ts"

import "./UkraineResidencePopup.vue?vue&type=style&index=0&id=24c66827&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c66827"]])

export default __exports__